<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="birdUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="birds"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-bird
      :bird="{ abbreviation: '', name: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-bird
      :key="birdUpdateKey"
      :bird="selectedBird"
      :visible="dialogType === 'update'"
      :id="selectedBird.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-bird
      :visible="dialogType === 'delete'"
      :bird="selectedBird"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-bird>
  </div>
</template>

<script>
import CreateBird from "./CreateBird";
import UpdateBird from "./UpdateBird";
import DeleteBird from "./DeleteBird";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateBird,
    UpdateBird,
    DeleteBird,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Beschreibung", value: "name" },

        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      birdUpdateKey: null,
      birdList: [],
      isLoading: false,
      dialogType: "",
      selectedBird: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "birds"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchBirds", "createBird", "updateBird"]),
    editBird(bird) {
      this.selectedBird = { ...bird };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },
    openModal(type, bird) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedBird = { ...bird };
      }
    },
    openDeleteModal(type, bird) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedBird = { ...bird };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedBird = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedBird = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createBird(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateBird(item);
      this.birdUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchBirds()
        .then(() => {
          //   this.$store.commit("setBirdTypeResults", response.data);
          this.birds = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
